module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container column dados-da-solicitacao",
    attrs: {
      "id": "visualizar-solicitacao"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "espacamento-interno visualizar-solicitacao"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "texto-informativo"
  }, [_c('span', {
    staticClass: "valor"
  }, [_vm._v("\n        Solicitação de Aporte de subsídio para aquisição da casa própria financiada nos\n        termos do " + _vm._s(_vm.artigoDaleiEstadual) + " e " + _vm._s(_vm.portariaNormativa) + ".\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "borda"
  }, [_c('h2', {
    staticClass: "titulo titulo_pequeno u-margem-inferior-media title is-5"
  }, [_vm._v("\n        Dados do(s) Proponente(s)\n      ")]), _vm._v(" "), _vm._l((_vm.proponentes), function(proponente, index) {
    return _c('div', [_c('span', {
      staticClass: "titulo titulo_pequeno"
    }, [_vm._v(" " + _vm._s(index + 1) + "º Proponente ")]), _vm._v(" "), _c('div', {
      staticClass: "field is-horizontal"
    }, [_c('div', {
      staticClass: "field-body field-body-linha"
    }, [_c('div', {
      staticClass: "field"
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Telefone || "NÃO INFORMADO"))])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Renda || "NÃO INFORMADO"))])])])]), _vm._v(" "), (proponente.Conjuge) ? _c('div', [_c('span', {
      staticClass: "titulo titulo_pequeno"
    }, [_vm._v("\n            Cônjuge (" + _vm._s(index + 1) + "º Proponente)\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "field is-horizontal"
    }, [_c('div', {
      staticClass: "field-body field-body-linha"
    }, [_c('div', {
      staticClass: "field"
    }, [_vm._m(6, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_vm._m(7, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_vm._m(8, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Telefone || "NÃO INFORMADO"))])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_vm._m(9, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Renda || "NÃO INFORMADO"))])])])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "field-body field-body-linha"
  }, [(_vm.solicitacaoEhDoBonusMoradia) ? _c('div', {
    staticClass: "field"
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.rendaTotalComprovada || "NÃO INFORMADO"))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._m(11), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.rendaTotal || "NÃO INFORMADO"))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "borda"
  }, [_c('h2', {
    staticClass: "titulo titulo_pequeno u-margem-inferior-media title is-5"
  }, [_vm._v("\n        Dados do Imóvel\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body field-body-linha"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._m(12), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.Construtora.Nome))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._m(13), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.Construtora.Cnpj))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._m(14), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.Construtora.Conta))])])]), _vm._v(" "), _c('div', {
    staticClass: "field-body field-body-linha"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._m(15), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Endereco.Cidade.Nome + " - " + _vm.imovel.Endereco.Cidade.EstadoNome))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._m(16), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.TipoDeEmpreendimento))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._m(17), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.Nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "field-body field-body-linha"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._m(18), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.EnderecoCompleto))])])]), _vm._v(" "), _c('div', {
    staticClass: "field-body field-body-linha"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._m(19), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.valorDaCompraEVenda))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._m(20), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subsidioDaAgehab))])])]), _vm._v(" "), _c('div', {
    staticClass: "field-body field-body-linha"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._m(21), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.valorDoFinanciamentoAprovado))])]), _vm._v(" "), (_vm.solicitacaoEhDoBonusMoradia) ? _c('div', {
    staticClass: "field"
  }, [_vm._m(22), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.descontoDaConstrutora))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field-body field-body-linha"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._m(23), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subsidioDoGovernoFederal))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._m(24), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.participacaoDoSolicitante))])])]), _vm._v(" "), _c('div', {
    staticClass: "field-body field-body-linha"
  }, [(!_vm.solicitacaoEhDoBonusMoradia) ? _c('div', {
    staticClass: "field"
  }, [_vm._m(25), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fgtsDoSolicitante))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "declaracoes field"
  }, [_vm._m(26), _vm._v(" "), _c('h2', {
    staticClass: "titulo titulo_pequeno u-margem-inferior-media u-margem-superior-media title is-5 no-print"
  }, [_vm._v("\n        Declarações\n      ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("(")]), _vm._v(" "), _c('span', [_vm._v(")")]), _vm._v(" Declaro veracidade das informações acima\n        prestadas, ciência e concordância com as condições estabelecidas na\n        " + _vm._s(_vm.portariaNormativa) + " e estou ciente de que, se falsas as declarações, ficarei\n        sujeito às penas da lei, ficando, ainda, obrigado(a) a devolver os valores\n        indevidamente recebidos da AGEHAB a título do subsídio, acrescidos de correção\n        monetária e juros.\n      ")]), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('div', {
    staticClass: "assinatura-container"
  }, [_c('div', {
    staticClass: "area-assinatura"
  }, [_c('div', {
    staticClass: "assinatura-linha"
  }), _vm._v(" "), _c('div', {
    staticClass: "label-assinatura"
  }, [_c('strong', [_vm._v(_vm._s(_vm.usuarioSolicitanteNome))])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "no-print botao botao_medio botao_cinza u-margem-direita-pequena",
    class: {
      'is-disabled': _vm.loading.visivel
    },
    attrs: {
      "to": {
        name: 'ListaDeSolicitacoes'
      }
    }
  }, [_vm._v("Voltar\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "ativo": _vm.loading,
      "altura": '60px',
      "largura": '60px'
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logos print has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imagens/logo-relatorio-retrato.jpg"),
      "width": "100%",
      "alt": "Logo AGEHAB/SEILOG"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-body-linha"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-esquerda-pequena title is-5 print titulo-relatorios"
  }, [_vm._v("\n        Solicitação de subsídio\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "titulo titulo_grande u-margem-inferior-pequena u-margem-esquerda-pequena title is-5 no-print titulo-relatorios"
  }, [_vm._v("\n        Solicitação de subsídio\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio",
    attrs: {
      "type": "button",
      "onclick": "window.print()"
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Imprimir\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Telefone:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Renda:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Telefone:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Renda:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Renda familiar apurada:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Somatório de renda:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Construtora:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CNPJ:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Conta*:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Cidade:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Tipo de Empreendimento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome do Empreendimento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Endereço:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Valor da compra e venda:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Solicitação de aporte/subsídio da AGEHAB:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Valor do financiamento concedido:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Desconto da construtora na entrada:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Valor do subsídio do Governo Federal:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Participação do proponente descontando subsídio e descontos:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Valor do FGTS do proponente a utilizar:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        *Conta de livre movimentação vinculada ao contrato de Apoio à Produção "), _c('br'), _vm._v("\n        *Conta indicada para a instituição Financeira para crédito dos valores do\n        financiamento do imóvel\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("(")]), _vm._v(" "), _c('span', [_vm._v(")")]), _vm._v(" Declaro estar de posse da declaração do\n        interessado que não foi atendido em outro programa habitacional, seja federal,\n        estadual ou municipal, quando o benefício se trata de uma unidade habitacional\n        completa, ou que seja proprietário de imóvel residencial.\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b754e7cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacao-de-subsidio/VisualizarSolicitacao.vue
// module id = 1138
// module chunks = 1